import * as React from "react";

class CenteredContent extends React.Component<React.HTMLAttributes<HTMLDivElement>> {
    public render(): React.ReactElement {
        const { children } = this.props;
        return <div className="centered_content">{children}</div>;
    }
}

export { CenteredContent };
